
export enum enTermsGenerationMoment {
    AFTER = 'after',
    BEFORE = 'before'
}